import { RestRequest, RestContext, ResponseFunction } from 'msw'
import {
  addToEntityListData,
  updateEntityListData,
  deleteEntityListData,
} from '../../modules/mockDataCommon'
import { requireAuthenticatedUser } from '../../decorators'
import { getOrderContactListData } from './mockData'

const postOrderContact = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return addToEntityListData(req, res, ctx, getOrderContactListData)
}

const patchOrderContact = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return updateEntityListData(req, res, ctx, getOrderContactListData)
}

const deleteOrderContact = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return deleteEntityListData(req, res, ctx, getOrderContactListData)
}

export const handlers = [
  {
    method: 'post',
    path: '/api/ordercontacts',
    handler: postOrderContact,
  },
  {
    method: 'patch',
    path: '/api/ordercontacts/:id',
    handler: patchOrderContact,
  },
  {
    method: 'delete',
    path: '/api/ordercontacts/:id',
    handler: deleteOrderContact,
  },
].map((h) => ({ ...h, ...{ handler: requireAuthenticatedUser(h.handler) } }))
